import { KitButton, KitIcon, KitText } from '@omni/kit/components';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import Colors from '@omni/kit/theming/Colors';
import Spacing from '@omni/kit/theming/Spacing';
import { useNavigation } from '@react-navigation/native';
import React, { ReactElement } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useSelector } from 'react-redux';

import Routes from '../../../../web/navigation/Routes';
import { DISCOVER_TAB } from '../../../Constants';
import {
  canCreateChannelsSelector,
  canCreateDirectMessageSelector,
  publicChannelListSelector,
} from '../../../redux/selectors';

//******************************************************************************
// Component
//******************************************************************************

interface EmptyConversationListProps {
  onCreatePressed: () => void;
}

export default function EmptyConversationList({
  onCreatePressed,
}: EmptyConversationListProps): ReactElement {
  const { t } = useTranslation(['messaging']);

  const canCreateChannels = useSelector(canCreateChannelsSelector);
  const canCreateDirectMessage = useSelector(canCreateDirectMessageSelector);
  const publicChannels = useSelector(publicChannelListSelector);

  // @ts-ignore
  let navigation;
  // @ts-ignore
  let history, params;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    navigation = useNavigation();
  } catch {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    history = useHistory();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    params = useParams();
  }

  const navToDiscover = () => {
    // @ts-ignore
    if (navigation) {
      // @ts-ignore
      navigation.navigate(DISCOVER_TAB);
    } else {
      // @ts-ignore
      history.push(Routes.groups(params.appKey));
    }
  };

  const _renderText = () => {
    if (publicChannels && publicChannels.length > 0) {
      return (
        <View>
          <KitText black fontSize={26} bold center style={styles.headerText}>
            {t('messaging:letsGetTheConversationStarted')}
          </KitText>
          <KitButton
            title='Join a group'
            onPress={navToDiscover}
            style={{ marginTop: Spacing.m }}
          />
          {canCreateDirectMessage || canCreateChannels ? (
            <KitButton
              secondary
              title='Start message'
              onPress={onCreatePressed}
              style={{ marginTop: Spacing.l }}
            />
          ) : null}
        </View>
      );
    } else if (canCreateDirectMessage || canCreateChannels) {
      return (
        <View>
          <KitText black fontSize={26} bold center style={styles.headerText}>
            {t('messaging:letsGetTheConversationStarted')}
          </KitText>
          <KitText gray fontSize={16} style={styles.paragraphText}>
            {t('messaging:directMessageGuidance')}
          </KitText>
        </View>
      );
    } else {
      return (
        <View>
          <KitText black fontSize={26} bold center style={styles.headerText}>
            {t('messaging:nothingToSeeHereYet')}
          </KitText>
          <KitText gray fontSize={16} style={styles.paragraphText}>
            {t('messaging:youHaventBeenAddedToAnyGroupsNotice')}
          </KitText>
          <KitText
            gray
            fontSize={16}
            style={[styles.paragraphText, { marginTop: Spacing.m }]}
          >
            {t('messaging:groupMembershipGuidance')}
          </KitText>
        </View>
      );
    }
  };

  return (
    <View style={styles.container}>
      <KitIcon name='messaging' color='#999b9e' size={44} />
      {_renderText()}
    </View>
  );
}

//******************************************************************************
// Styles
//******************************************************************************
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.N0,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: Spacing.xxl,
    paddingBottom: Spacing.xxl,
  },
  headerText: {
    marginTop: Spacing.m,
    marginBottom: Spacing.m,
  },
  paragraphText: {
    lineHeight: 24,
    textAlign: 'center',
  },
});
function useHistory(): any {
  throw new Error('Function not implemented.');
}

function useParams(): any {
  throw new Error('Function not implemented.');
}
